import PropTypes from 'prop-types';

const SVG = ({
  style = {
    fill: '#000000',
  },
}) => (
  <svg style={style} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 57.03 55.46">
    <ellipse
      cx="15.92"
      cy="19.74"
      rx="14.92"
      ry="14.4"
      fill="none"
      stroke="#000"
      strokeMiterlimit="10"
      strokeWidth="2"
    />
    <ellipse
      cx="32.4"
      cy="40.06"
      rx="14.92"
      ry="14.4"
      fill="none"
      stroke="#000"
      strokeMiterlimit="10"
      strokeWidth="2"
    />
    <ellipse
      cx="41.1"
      cy="15.4"
      rx="14.92"
      ry="14.4"
      fill="none"
      stroke="#000"
      strokeMiterlimit="10"
      strokeWidth="2"
    />
    <path
      d="M12.01 10.11a10.3 10.3 0 00-6.64 7.74M51 13.01a10.32 10.32 0 00-7.35-7.07"
      fill="none"
      stroke="#000"
      strokeMiterlimit="10"
      strokeWidth="2"
    />
  </svg>
);

SVG.propTypes = {
  style: PropTypes.object.isRequired,
};

export default SVG;
